<template>
  <v-card>
    <v-card-title class="green lighten-4 font-weight-bold primary--text"
      >Termos do plano</v-card-title
    >
    <v-card-subtitle class="green lighten-4"
      >Leia atentamente antes de aceitar</v-card-subtitle
    >
    <v-card-text class="pt-4">
      <p v-html="textoTermos"></p>

      <v-checkbox
        v-model="aceitouTermosModel"
        label="Declaro que li e aceito os termos descritos acima"
      ></v-checkbox>
    </v-card-text>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("planoSaude", ["textoTermos", "aceitouTermos"]),
    aceitouTermosModel: {
      get: function () {
        return this.aceitouTermos;
      },
      set: function (value) {
        this.setAceitouTermos(value);
      },
    },
  },
  methods: {
    ...mapMutations("planoSaude", ["setAceitouTermos"]),
  },
};
</script>

<style>
</style>